import React from "react";
import * as Styled from "./styles";
import { useClinicalBudget } from "shared/providers/ClinicalBudget";
import { IoClose } from "react-icons/io5";

const ARCADA_NUMS = [100, 101];
const HEMIARCADA_NUMS = [102, 103, 104, 105];

const BudgetArcadaModal: React.FC = () => {
  const {
    showArcadaModal,
    setShowArcadaModal,
    selectedArcadas,
    setSelectedArcadas,
    selectedProc,
    selectedArea,
    selectedCategoria,
    selectedValor,
    selectedCatprocId,
    effectiveUsaArcada,
    effectiveUsaHemiarcada,
    addItem,
    setSelectedProc,
    setSelectedCategoria,
    setSelectedGrupo,
    formatMoeda,
    showValues,
    elementosRef,
  } = useClinicalBudget();

  if (!showArcadaModal || !selectedProc) return null;

  const valor = selectedValor || selectedProc.valor;
  const grupoNome = selectedCategoria?.nome ?? '';

  const handleToggle = (elem: number) => {
    setSelectedArcadas(prev => {
      if (prev.includes(elem)) return prev.filter(e => e !== elem);
      return [...prev, elem];
    });
  };

  const handleClose = () => {
    setShowArcadaModal(false);
    setSelectedArcadas([]);
    setSelectedProc(null);
    setSelectedCategoria(null);
    setSelectedGrupo(null);
  };

  const handleConfirm = () => {
    if (selectedArcadas.length === 0) return;

    selectedArcadas.forEach(elem => {
      addItem({
        procId: selectedProc.id,
        procNome: selectedProc.nome,
        area: selectedArea,
        elemento: elem,
        valor: valor,
        grupoId: 0,
        grupoNome: grupoNome,
        qtde: 1,
        faces: '',
        catprocId: selectedCatprocId || 0,
        gpitemId: 0,
        obsPersonalizado: '',
      });
    });

    setShowArcadaModal(false);
    setSelectedArcadas([]);
    setSelectedProc(null);
    setSelectedCategoria(null);
    setSelectedGrupo(null);
  };

  const totalPreview = selectedArcadas.length * valor;

  return (
    <Styled.ModalOverlay onClick={handleClose}>
      <Styled.ModalContent onClick={e => e.stopPropagation()}>
        <Styled.ModalHeader>
          <Styled.CloseButton onClick={handleClose}>
            <IoClose size={24} />
          </Styled.CloseButton>
          <h3>Selecione a Região</h3>
          <p>
            {selectedProc.nome}
            {grupoNome && ` (${grupoNome})`}
          </p>
          {showValues && (
            <p>R$ {formatMoeda(valor)} por região</p>
          )}
        </Styled.ModalHeader>

        <Styled.ModalBody>
          {effectiveUsaArcada && (
            <>
              <Styled.SectionTitle>Arcadas</Styled.SectionTitle>
              <Styled.OptionsGrid>
                {elementosRef
                  .filter(el => ARCADA_NUMS.includes(el.numero))
                  .map(el => (
                    <Styled.ArcadaOption
                      key={el.numero}
                      selected={selectedArcadas.includes(el.numero)}
                      onClick={() => handleToggle(el.numero)}
                    >
                      <span className="label">{el.descricao}</span>
                    </Styled.ArcadaOption>
                  ))}
              </Styled.OptionsGrid>
            </>
          )}

          {effectiveUsaHemiarcada && (
            <>
              <Styled.SectionTitle>Hemi-Arcadas</Styled.SectionTitle>
              <Styled.OptionsGrid>
                {elementosRef
                  .filter(el => HEMIARCADA_NUMS.includes(el.numero))
                  .map(el => (
                    <Styled.ArcadaOption
                      key={el.numero}
                      selected={selectedArcadas.includes(el.numero)}
                      onClick={() => handleToggle(el.numero)}
                    >
                      <span className="label">{el.descricao}</span>
                    </Styled.ArcadaOption>
                  ))}
              </Styled.OptionsGrid>
            </>
          )}

          {selectedArcadas.length > 0 && showValues && (
            <Styled.TotalPreview>
              <div className="count">{selectedArcadas.length} região(ões) selecionada(s)</div>
              <div className="total">Total: R$ {formatMoeda(totalPreview)}</div>
            </Styled.TotalPreview>
          )}
        </Styled.ModalBody>

        <Styled.ModalFooter>
          <Styled.FooterButton variant="secondary" onClick={handleClose}>
            Cancelar
          </Styled.FooterButton>
          <Styled.FooterButton
            variant="primary"
            onClick={handleConfirm}
            disabled={selectedArcadas.length === 0}
          >
            Confirmar ({selectedArcadas.length})
          </Styled.FooterButton>
        </Styled.ModalFooter>
      </Styled.ModalContent>
    </Styled.ModalOverlay>
  );
};

export { BudgetArcadaModal };
